export default {
	BASE_URL: "https://carrefourdillon.solutia.live",
  MODE: 'production',
	GA_CODE: 'G-KCGZYPLFJW',
};
